import React, { useState } from "react";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="main-header-wrapper2 float_left mt-0 mb-1">
      {/* Desktop Header */}
      <div className="sb-header-section2 d-xl-block d-lg-block d-md-none d-sm-none d-none">
        <div className="">
          <div className="row">
            <div className="col-lg-3 col-md-3">
              <div className="logo-wrapper2">
                <a href="/">
                  <img
                    src="/images/logo2.png"
                    alt="Logo"
                    style={{ height: "80px" }}
                  />
                </a>
              </div>
            </div>
            <div className="col-lg-9 col-md-9">
              <div className="menu-top-section2 ">
                <ul>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fas fa-map-marker-alt"></i>
                      </span>
                      6th Cross, Arulananda Nagar, Thanjavur, India.
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fas fa-phone"></i>
                      </span>
                      04362 - 238 235
                    </a>
                  </li>
                  <li>
                    <ul>
                      <li>
                        <a href="https://www.facebook.com">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.twitter.com">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.pinterest.com">
                          <i className="fab fa-pinterest-p"></i>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="btn2">
                    <span className="text-light">
                      <a href="/login">Login</a> /{" "}
                      <a href="/register">Register</a>
                    </span>
                  </li>
                </ul>
              </div>

              {/* Desktop Menu Links */}
              <div
                className="d-flex hstack gap-5 fw-bold mt-4 justify-content-center"
                style={{ fontSize: "20px" }}
              >
                <a className="text-decoration-none text-dark" href="/">
                  Home
                </a>
                <a className="text-decoration-none text-dark" href="#">
                  About Us
                </a>
                <a className="text-decoration-none text-dark" href="/contactUs">
                  ContactUs
                </a>
                <a className="text-decoration-none text-dark" href="#">
                  Heritage
                </a>
                <a className="text-decoration-none text-dark" href="#">
                  Culture
                </a>
                <a className="text-decoration-none text-dark" href="">
                  Agriculture
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Header*/}
      <div className="d-block d-lg-none bg-white border-bottom shadow-sm py-3 position-relative">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              <button
                className="text-dark bg-transparent rounded-circle p-2 border-0"
                onClick={() => setMenuOpen(true)}
              >
                <i className="fas fa-bars"></i>
              </button>
              <a href="#">
                <img
                  src="/images/logo2.png"
                  alt="Logo"
                  style={{ height: "45px" }}
                />
              </a>
            </div>

            <div className="d-flex gap-2">
              <a
                href="/login"
                className="btn btn-sm btn-primary rounded-pill px-3"
              >
                Login
              </a>
              <a
                href="/register"
                className="btn btn-sm btn-outline-primary rounded-pill px-3"
              >
                Register
              </a>
            </div>
          </div>

          <div className="mt-3 text-muted" style={{ fontSize: "14px" }}>
            <div>
              <i className="fas fa-map-marker-alt me-2"></i>6th Cross,
              Arulananda Nagar, Thanjavur
            </div>
            <div>
              <i className="fas fa-phone me-2"></i>04362 - 238 235
            </div>
          </div>

          <div className="d-flex gap-3 mt-2">
            <a href="https://www.facebook.com">
              <i className="fab fa-facebook-f text-primary"></i>
            </a>
            <a href="https://www.twitter.com">
              <i className="fab fa-twitter text-info"></i>
            </a>
            <a href="https://www.instagram.com">
              <i className="fab fa-instagram text-danger"></i>
            </a>
            <a href="https://www.pinterest.com">
              <i className="fab fa-pinterest-p text-danger"></i>
            </a>
          </div>
        </div>

        {menuOpen && (
          <div
            className="position-fixed top-0 start-0 bg-white p-4 shadow-lg"
            style={{
              width: "260px",
              height: "100vh",
              zIndex: 1050,
              transition: "transform 0.3s ease",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <a href="#">
                <img
                  src="images/logo2.png"
                  alt="Logo"
                  style={{ height: "40px" }}
                />
              </a>
              <button
                className="btn text-dark border-0"
                onClick={() => setMenuOpen(false)}
              >
                <i className="fas fa-times fs-5"></i>
              </button>
            </div>

            <div
              className="mt-4 d-flex flex-column gap-4 fw-bold"
              style={{ fontSize: "18px" }}
            >
              <a className="text-decoration-none text-dark" href="/">
                Home
              </a>
              <a className="text-decoration-none text-dark" href="#">
                About Us
              </a>
              <a className="text-decoration-none text-dark" href="/contactUs">
                Contact Us
              </a>
              <a className="text-decoration-none text-dark" href="#">
                Heritage
              </a>
              <a className="text-decoration-none text-dark" href="#">
                Culture
              </a>
              <a className="text-decoration-none text-dark" href="#">
                Agriculture
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
